import { Link } from 'react-router-dom';
import { Button } from '../components/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 dark:bg-avemio-dark-bg">
      <div className="text-center">
        <h1 className="mb-4 text-9xl font-bold text-gray-300 dark:text-avemio-dark-border">404</h1>
        <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-avemio-dark-text-primary">Page Not Found</h2>
        <p className="mb-8 text-gray-600 dark:text-avemio-dark-text-secondary">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button>Go Back Home</Button>
        </Link>
      </div>
    </div>
  );
}

